// The pieces every Premium feature shows a free account (docs/billing/premium-features.md): a "Premium" badge on
// the control, and a note offering Subscribe once it is chosen. The feature stays visible; nothing is hidden.
import { useTranslation } from 'react-i18next';
import type { PremiumFeature } from '@/auth/me';
import { openSubscribe } from './billing';
import styles from './Premium.module.css';

export function PremiumBadge() {
  const { t } = useTranslation();
  return <span className={styles.badge}>{t('premium.badge')}</span>;
}

/** "<what> is a Premium feature. Subscribe": Subscribe offers Premium for the feature, then carries on. */
export function PremiumNote({
  feature,
  children,
  then,
}: {
  feature: PremiumFeature;
  /** What the feature is; by default the feature's own line. */
  children?: React.ReactNode;
  then?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <span className={styles.note} role="status">
      {children ?? t('premium.note', { feature: t(`subscribe.feature.${feature}.title`) })}{' '}
      <button type="button" className={styles.subscribe} onClick={() => openSubscribe({ feature, then })}>
        {t('nav.subscribe')}
      </button>
    </span>
  );
}
